/* ENCORE department-store helpers: quick add + shelf arrows */
(function () {
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-ds-add]');
    if (btn) {
      e.preventDefault();
      if (btn.disabled) return;
      var id = btn.getAttribute('data-ds-add');
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      try {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.addItemToCart === 'function') {
          await drawer.addItemToCart(Number(id));
          if (typeof drawer.open === 'function') drawer.open(btn);
        } else {
          var r = await fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(id), quantity: 1 })
          });
          if (r.ok) window.location.href = (window.routes && routes.cart_url) || '/cart';
        }
        btn.textContent = 'Added';
      } catch (err) {
        btn.textContent = label;
      }
      setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1600);
      return;
    }
    var arrow = e.target.closest('[data-ds-scroll]');
    if (arrow) {
      var track = document.getElementById(arrow.getAttribute('aria-controls'));
      if (!track) return;
      var dir = arrow.getAttribute('data-ds-scroll') === 'next' ? 1 : -1;
      track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.85, 240), behavior: 'smooth' });
    }
  });

  function syncArrows(track) {
    var sec = track.closest('[data-ds-shelf]');
    if (!sec) return;
    var prev = sec.querySelector('[data-ds-scroll="prev"]');
    var next = sec.querySelector('[data-ds-scroll="next"]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
    sec.classList.toggle('ds-shelf--static', max <= 2);
  }
  function init() {
    document.querySelectorAll('[data-ds-track]').forEach(function (t) {
      if (t.dataset.dsReady) return; t.dataset.dsReady = '1';
      t.addEventListener('scroll', function () { syncArrows(t); }, { passive: true });
      window.addEventListener('resize', function () { syncArrows(t); });
      syncArrows(t);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
